import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {fetchUserById} from "../../services/Api/UserApi";

export const UserDetails = () => {
    const {id} = useParams();
    const [user, setUser] = useState({})

    const getUser = async () => {
        const data = await fetchUserById(id)
        setUser(data)
    }

    useEffect(() => {
        getUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <div>
            <h1>User : {user.username}</h1>
            <p>Todo : détails à venir</p>
        </div>
    )
}